import { useSyncExternalStore } from 'react';

export const POSITIONS_EXPERIENCE_SUBSTEP = 3;

let currentSubStep = 1;
const listeners = new Set<() => void>();

export const setPositionsSubStep = (subStep: number): void => {
  if (subStep === currentSubStep) {
    return;
  }
  currentSubStep = subStep;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = (): number => currentSubStep;

export const usePositionsSubStep = (): number =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
